// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_fd-3";
export var flatBottomCorners = "_fd-5";
export var productImage = "_fd-0";
export var quantityContainer = "_fd-2";
export var quantityHeader = "_fd-6";
export var tooltip = "_fd-1";
export var wrapAndEllipsesOverflow = "_fd-4";